import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import {useProductStore} from '@/store/good';
import {useTrademarkStore} from '@/store/mark';
import {useOwnerStore} from '@/store/owner';
import useCountry from '@/composables/countryDependable';
import {useTermOfUseStore} from '@/store/terms-of-use';
import {generateUniqeReference} from '@/core/util/reference-utils';
import LocalStorageDecorator from '@/store/storage/local-storage-decorator';


export const useApplicationStore = defineStore('applicationStore', () => {
    const trademarkStore = useTrademarkStore();
    const productStore = useProductStore();
    const ownerStore = useOwnerStore();
    const termOfUseStore = useTermOfUseStore();
    const hasValidation = ref(false);
    const country = useCountry();
    const appReference = ref(generateUniqeReference(country.displayCode));


    const generateReference = (code: string) => {
        if (appReference.value) {
            return;
        }

        appReference.value = generateUniqeReference(code)
    };

    function resetData() {
        hasValidation.value = false;
        appReference.value = generateUniqeReference(country.displayCode);
    }

    const isApplicationValid = computed(() => {
        return trademarkStore.isTrademarkStepValid && productStore.isProductStepValid && ownerStore.isOwnerStepValid && termOfUseStore.isTermOfUseStepValid;
    })

    function validateApplication() {
        if (isApplicationValid.value) {
            return true
        }

        hasValidation.value = true;
        return false
    }

    return { validateApplication, hasValidation, resetData, appReference, generateReference }
},{
    persist: {
        storage: LocalStorageDecorator
    },
});
